// Lib
import { handleActions, Action } from 'redux-actions';

// Actions
import { UpdateNotificationsPayload } from 'actions/notifications';
import {
  mapNotificationEntityToNotification,
  mapPusherEventPayloadToNotification,
} from 'utils/notifications';
import { pusherEvent, PusherEventPayload } from 'actions/pusher';
import { CombinedNotificationData } from 'types/notifications';
import { RecruiterEvent } from 'types/pusher';
import { setMessages, cleanMessages } from './actions';

type NotificationsState = CombinedNotificationData[];

const initialState: any = [];

const handlePusherEvent = (
  currentState: NotificationsState,
  { payload }: Action<PusherEventPayload>
) => {
  if (payload.event === RecruiterEvent.CANDIDATE_NOTE) {
    const notification = mapPusherEventPayloadToNotification(payload);
    const filteredState = currentState.filter(
      stateNotification => stateNotification.id !== notification.id
    );
    return [...filteredState, notification];
  }
  return currentState;
};

const handleUpdateMessages = (_: any, { payload }: Action<UpdateNotificationsPayload>) => {
  const notifications = payload.map(notification =>
    mapNotificationEntityToNotification(notification)
  );
  return [...notifications];
};

export default handleActions(
  {
    [pusherEvent as any]: handlePusherEvent,
    [setMessages as any]: handleUpdateMessages,
    [cleanMessages as any]: () => initialState,
  },
  initialState
);
